import { render, staticRenderFns } from "./Point.vue?vue&type=template&id=645cd510&scoped=true&"
import script from "./Point.vue?vue&type=script&lang=js&"
export * from "./Point.vue?vue&type=script&lang=js&"
import style0 from "./Point.vue?vue&type=style&index=0&id=645cd510&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645cd510",
  null
  
)

export default component.exports